<template>
<div class="col-12" :data-offer="!!accepted.id" id="manage-trade-offers">

    <div class="col-12 shadow bg-light" id="listed-pin">
        <div class="container">
            <div class="row">
                
                <div class="col-12 col-md">
                    <div class="card my-md-3 border-0 bg-transparent" style="max-width: 540px;">
                        <div class="row g-0">
                            <div class="col-3 d-flex align-items-center justify-content-center">
                                <picture>
                                    <!-- <source :srcset="'https://pinandpop.s3.amazonaws.com' + listing.pinventory.pin.primary_image.thumbs.webp" type="image/webp"> -->
                                    <!-- <source :srcset="'https://pinandpop.s3.amazonaws.com' + listing.pinventory.pin.primary_image.thumbs.jpg" type="image/jpeg"> -->
                                    <!-- <img :src="'https://pinandpop.s3.amazonaws.com' + listing.pinventory.pin.primary_image.thumbs.jpg" class="align-self-start rounded-start" :alt="listing.pinventory.pin.name"> -->
                                    <source :srcset="listing.collection.collectible.primary_image.srcset.webp" type="image/webp">
                                    <source :srcset="listing.collection.collectible.primary_image.srcset.jpg" type="image/jpeg">
                                    <img :src="listing.collection.collectible.primary_image.srcset.jpg" class="align-self-start rounded-start" :alt="listing.collection.collectible.name">
                                </picture>
                            </div>
                            <div class="col-9">
                                <div class="card-body p-1">
                                    <h5 v-if="isUser" class="card-title">Your Pin:</h5>
                                    <!-- <h5 v-else class="card-title">{{ listing.pinventory.user.username }}'s Pin:</h5> -->
                                    <h5 v-else class="card-title">{{ listing.collection.user.username }}'s Pin:</h5>
                                    <!-- <p class="card-text mb-1"><a :href="'/pins/' + listing.pinventory.pin.id" target="_blank" class="text-decoration-underline">{{ listing.pinventory.pin.title }}</a></p> -->
                                    <p class="card-text mb-1"><a :href="'/pins/' + listing.collection.collectible.id" target="_blank" class="text-decoration-underline">{{ listing.collection.collectible.title }}</a></p>
                                    <!-- <h5 v-if="listing.pinventory.pin.rarity" class="rarity-container">
                                        <span class="rarity badge" :class="listing.pinventory.pin.rarity.slug">{{ listing.pinventory.pin.rarity.slug }}</span>
                                    </h5> -->
                                    <h5 v-if="listing.collection.collectible.rarity" class="rarity-container">
                                        <span class="rarity badge" :class="listing.collection.collectible.rarity.slug">{{ listing.collection.collectible.rarity.slug }}</span>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="accepted.id" class="col-12 col-md">
                    <div class="card my-md-3" style="max-width: 540px;">
                        <div class="row g-0">
                            <div class="col-3 d-flex align-items-center justify-content-center">
                                <picture>
                                    <!-- <source :srcset="'https://pinandpop.s3.amazonaws.com' + accepted.collection.collectible.primary_image.thumbs.webp" type="image/webp"> -->
                                    <!-- <source :srcset="'https://pinandpop.s3.amazonaws.com' + accepted.collection.collectible.primary_image.thumbs.jpg" type="image/jpeg"> -->
                                    <!-- <img :src="'https://pinandpop.s3.amazonaws.com' + accepted.collection.collectible.primary_image.thumbs.jpg" class="align-self-start rounded-start" :alt="accepted.collection.collectible.name"> -->
                                    <source :srcset="accepted.collection.collectible.primary_image.srcset.webp" type="image/webp">
                                    <source :srcset="accepted.collection.collectible.primary_image.srcset.jpg" type="image/jpeg">
                                    <img :src="accepted.collection.collectible.primary_image.srcset.jpg" class="align-self-start rounded-start" :alt="accepted.collection.collectible.name">
                                </picture>
                            </div>
                            <div class="col-9">
                                <div class="card-body p-1">
                                    <h5 v-if="isUser" class="card-title">Your Choice:</h5>
                                    <p class="card-text mb-1" style="line-height: 1rem; font-size: 0.75rem"><a :href="'/pins/' + accepted.collection.collectible.id" target="_blank" class="text-decoration-underline">{{ accepted.collection.collectible.title }}</a></p>

                                    
                                    <p class="card-text mb-1"><small class="text-muted">
                                        Backer Card/Box:
                                        <strong v-if="accepted.collection.ledger && accepted.collection.ledger.backer_card">{{ accepted.collection.ledger.backer_card.toUpperCase() }}</strong>
                                        <span v-else>N/A</span>
                                    </small></p>
                                    <p class="card-text mb-0">
                                        <small class="text-muted">
                                            Condition: <strong v-if="accepted.collection.ledger && accepted.collection.ledger.condition">{{ accepted.collection.ledger.condition.toUpperCase() }}</strong>
                                            <span v-if="accepted.collection.ledger && accepted.collection.ledger.condition_notes"> - {{ accepted.collection.ledger.condition_notes }}</span>
                                        </small>
                                    </p>
                                    

                                    <h5 v-if="accepted.collection.collectible.rarity" class="rarity-container mt-1 mb-0" style="position: absolute; top: 0; right: 0;">
                                        <span class="rarity badge" :class="accepted.collection.collectible.rarity.slug">{{ accepted.collection.collectible.rarity.slug }}</span>
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div v-if="!listedPin.accepted" class="text-end"><button @click="accepted = { id: null }" type="button" class="btn btn-link text-danger">Remove</button></div>
                    </div>
                </div>

            <!-- <div class="media py-2">
                <picture>
                    <source :srcset="'https://pinandpop.s3.amazonaws.com' + listing.pinventory.pin.primary_image.thumbs.webp" type="image/webp">
                    <source :srcset="'https://pinandpop.s3.amazonaws.com' + listing.pinventory.pin.primary_image.thumbs.jpg" type="image/jpeg">
                    <img :src="'https://pinandpop.s3.amazonaws.com' + listing.pinventory.pin.primary_image.thumbs.jpg" class="align-self-start me-3" width="100" :alt="listing.pinventory.pin.name">
                </picture>
                <div class="media-body">
                    <h4 v-if="isUser">Your Pin:</h4>
                    <h4 v-else>{{ listing.pinventory.user.username }}'s Pin:</h4>
                    <p class="pin-title mb-0">{{ listing.pinventory.pin.title }}</p>
                    <h5 v-if="listing.pinventory.pin.rarity" class="rarity-container"><span class="rarity badge" :class="listing.pinventory.pin.rarity.slug">{{ listing.pinventory.pin.rarity.slug }}</span></h5>
                </div>
            </div>
            </div> -->

            <!-- <div v-if="accepted.id" class="col-12 col-md">
            <div class="media py-2">
                <picture>
                    <source :srcset="'https://pinandpop.s3.amazonaws.com' + accepted.collection.collectible.primary_image.thumbs.webp" type="image/webp">
                    <source :srcset="'https://pinandpop.s3.amazonaws.com' + accepted.collection.collectible.primary_image.thumbs.jpg" type="image/jpeg">
                    <img :src="'https://pinandpop.s3.amazonaws.com' + accepted.collection.collectible.primary_image.thumbs.jpg" class="align-self-start me-3" width="100" :alt="accepted.collection.collectible.name">
                </picture>
                <div class="media-body">
                    <h4>Your Choice:</h4>
                    <p class="pin-title mb-0">{{ accepted.collection.collectible.title }}</p>
                    <h5 v-if="accepted.collection.collectible.rarity" class="rarity-container"><span class="rarity badge" :class="accepted.collection.collectible.rarity.slug">{{ accepted.collection.collectible.rarity.slug }}</span></h5>
                </div>
            </div>
            </div> -->

            </div>
        </div>
    </div>

    <div v-if="traders.length" class="row" id="offers-thumbs">

        <div class="col-12 mt-5 mb-3">
            <div v-if="!canTrade" class="alert alert-warning" role="alert">
                <h4 class="alert-heading">Trade Lock <strong>{{ formattedTimerCount }}</strong></h4>
                <div>In order to give everyone a chance to make offers, you'll be able to accept trades once the Trade Lock expires.</div>
            </div>
            <h3>Trade Offers:</h3>
            <hr>
        </div>

        <div class="col-12 coll-thumbs">
            <div v-for="(trader, index) in traders" :key="trader.id" class="row mb-5">
                <div class="col-12 my-2 border-top pt-2">
                    <!-- <h5>Trader #{{ index + 1 }} <span v-if="enhanced"> - {{ trader.name }}</span> <button v-if="!listedPin.accepted" @click="declineTrader = trader.id" type="button" class="btn btn-sm btn-link text-danger float-end" data-bs-toggle="modal" data-bs-target="#trade-confirm"><i class="fa-solid fa-ban"></i> Decline This Trader's Offers</button></h5> -->                    
                </div>

                <div class="alert alert-light">
                    <div class="d-flex justify-content-between">
                        <h5 class="fs-4 fw-bold">
                            <!-- {{ trader.display_name }} #{{ index + 1 }} -->
                            {{ trader.display_name }}
                            <template v-if="enhanced && !trader.profile_url">
                                <span>(<a :href="trader.profile_url" target="_blank">{{ trader.name }}</a>)</span>
                            </template>
                        </h5>
                        <button v-if="!listedPin.accepted" @click="declineTrader = trader.id" type="button" class="btn btn-sm btn-link text-danger float-end" data-bs-toggle="modal" data-bs-target="#trade-confirm"><i class="fa-solid fa-ban"></i> Decline This Trader's Offers</button>
                    </div>

                    <div class="mt-3" style="max-width: 330px;">

                        <div class="">

                            <div class="d-flex justify-content-between">
                                <div class="">Accepts Trades</div>
                                <div class="d-flex gap-1 align-items-center fw-bold">
                                    <template v-for="n in Math.floor(trader.ratings.canceled_rating)">
                                    <i class="fa-solid fa-star"></i>
                                    </template>
                                    <template v-for="n in (5 - Math.floor(trader.ratings.canceled_rating))">
                                    <i v-if="n === 1 && (trader.ratings.canceled_rating - Math.floor(trader.ratings.canceled_rating) < 1)" class="fa-solid fa-star-half-stroke"></i>
                                    <i v-else class="fa-light fa-star"></i>
                                    </template>
                                </div>
                            </div>
                            <div class="small text-end">
                                <p class="text-muted">
                                    <span v-if="trader.ratings.canceled_rating < 2.5">Frequently</span>
                                    <span v-else-if="trader.ratings.canceled_rating < 3.5">Sometimes</span>
                                    <span v-else-if="trader.ratings.canceled_rating < 5">Rarely</span>
                                    <span v-else>Never</span>
                                    cancels trades of verified pins
                                </p>
                            </div>
                        
                        </div>
                        <div class="mt-3">

                            <div class="d-flex justify-content-between">
                                <div class="">Pins-in-Hand</div>
                                <div class="d-flex gap-1 align-items-center fw-bold">
                                    <template v-for="n in Math.floor(trader.ratings.missing_rating)">
                                    <i class="fa-solid fa-star"></i>
                                    </template>
                                    <template v-for="n in (5 - Math.floor(trader.ratings.missing_rating))">
                                    <i v-if="n === 1 && (trader.ratings.missing_rating - Math.floor(trader.ratings.missing_rating) < 1)" class="fa-solid fa-star-half-stroke"></i>
                                    <i v-else class="fa-light fa-star"></i>
                                    </template>
                                </div>
                            </div>
                            <div class="small text-end">
                                <p class="text-muted">
                                    <span v-if="trader.ratings.missing_rating < 2.5">Frequently</span>
                                    <span v-else-if="trader.ratings.missing_rating < 3.5">Sometimes</span>
                                    <span v-else-if="trader.ratings.missing_rating < 5">Rarely</span>
                                    <span v-else>Never</span>
                                    has canceled trades due to missing pins
                                </p>
                            </div>

                        </div>

                    </div>
                </div>

                <div v-if="tradeOffers.filter(o => o.collection.user_id === trader.id)[0].is_listed_grail" class="col-12">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Grail Alert!</h4>
                        <p>Your pin is in this trader's Grail list!</p>
                    </div>
                </div>
                <div v-else-if="tradeOffers.filter(o => o.collection.user_id === trader.id)[0].is_listed_iso" class="col-12">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">ISO Alert!</h4>
                        <p>Your pin is in this trader's ISO list!</p>
                    </div>
                </div>

                <div v-for="offer in tradeOffers.filter(o => o.collection.user_id === trader.id)" :key="offer.id" class="col-6 col-md-3 col-lg-2 my-4 trade-offer" :class="{ inactive: offer.unavailable_at, 'iso-match': offer.iso_match }">
                    <div v-if="offer.grail_match" class="bg-grail p-2 text-light rounded-top text-center" title="This pin is in your GRAIL list!">
                        <strong><i class="fa-regular fa-crown"></i> GRAIL ALERT</strong>
                    </div>
                    <div v-else-if="offer.iso_match" class="bg-warning p-2 text-light rounded-top text-center" title="This pin is in your ISO list!">
                        <strong><i class="fa-regular fa-magnifying-glass-plus"></i> ISO ALERT</strong>
                    </div>
                    <h5 v-if="offer.collection.collectible.rarity" class="rarity-container position-absolute"><span class="rarity badge" :class="offer.collection.collectible.rarity.slug">{{ offer.collection.collectible.rarity.slug }}</span></h5>
                    <div class="card h-100">
                        <picture>
                            <source :srcset="'https://pinandpop.s3.amazonaws.com' + offer.collection.collectible.primary_image.thumbs.webp" type="image/webp">
                            <source :srcset="'https://pinandpop.s3.amazonaws.com' + offer.collection.collectible.primary_image.thumbs.jpg" type="image/jpeg">
                            <img :src="'https://pinandpop.s3.amazonaws.com' + offer.collection.collectible.primary_image.thumbs.jpg" class="card-img-top" :alt="offer.collection.collectible.name">
                        </picture>
                        <div class="card-body">
                            <small>{{ offer.collection.collectible.title }}</small>
                        </div>
                        <template v-if="isUser">
                            <div v-if="offer.accepted_at" class="card-footer text-center bg-success">
                                <strong class="text-light">ACCEPTED</strong>
                            </div>
                            <div v-else-if="offer.declined_at" class="card-footer text-center bg-secondary">
                                <small class="text-light">Not Accepted</small>
                            </div>
                            <template v-else>
                                <div v-if="offer.unavailable_at" class="card-footer">
                                    <h6 class="text-center"><span class="badge bg-secondary">Not Available</span></h6>
                                </div>
                                <div v-else-if="canTrade" class="card-footer p-0">
                                    <div class="form-check" :class="{ 'bg-success': accepted.id === offer.id }">
                                        <label @click="accepted = offer" class="form-check-label" :for="'offer-' + offer.collection.id + '-for-' + listing.id"></label>
                                        <input class="form-check-input d-none" type="radio" :name="'for-' + listing.id" :id="'offer-' + offer.collection.id + '-for-' + listing.id" :value="offer.id">
                                        <span v-if="accepted.id === offer.id" class="text-light">Selected</span>
                                        <span v-else>Select Choice</span>
                                    </div>
                                </div>
                                <div v-else class="card-footer alert-warning text-center">TRADE LOCK</div>
                            </template>
                        </template>

                        <div v-if="offer.already_own" class="bg-own p-1 text-light text-center" :class="{'rounded-bottom': !offer.iso_match && !offer.grail_match}">
                            <small>Already OWN</small>
                        </div>
                        <div v-if="offer.grail_match" class="bg-grail p-1 text-light rounded-bottom text-center">
                            <small>In your GRAIL list</small>
                        </div>
                        <div v-else-if="offer.iso_match" class="bg-warning p-1 text-light rounded-bottom text-center">
                            <small>In your ISO list</small>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div v-if="isUser && !listedPin.accepted && tradeOffers.filter(o => !o.unavailable_at).length" class="col-12 mt-4 col-lg-6 offset-lg-3">

            <div v-if="tradeError" class="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Pin Unavailable!</strong> {{ tradeError }}
                <button @click="tradeError = null" type="button" class="btn-close" data-dismiss="alert" aria-label="Close"></button>
            </div>

            <div v-if="!canTrade" class="alert alert-warning" role="alert">
                <h4 class="alert-heading">Trade Lock <strong>{{ formattedTimerCount }}</strong></h4>
                <p>In order to give everyone a chance to make offers, you'll be able to accept trades once the
                    Trade Lock expires.</p>
                <small>NOTE: You can still decline all offers during the Trade Lock period.</small>
            </div>

            <div class="d-flex justify-content-between">
                <button @click="declineAll = true" type="button" class="btn btn-lg btn-danger" data-bs-toggle="modal" data-bs-target="#trade-confirm"><i class="fa-solid fa-ban"></i> Decline All<span class="d-none d-sm-inline"> Offers</span></button>
                <button v-if="canTrade" @click="declineAll = false" type="button" class="btn btn-lg btn-success" data-bs-toggle="modal" data-bs-target="#trade-confirm" :disabled="!accepted.id || isPending"><i class="fa-regular fa-circle-check"></i> Accept<span class="d-none d-sm-inline"> Choice</span></button>
            </div>
        </div>
        <div v-else-if="isUser && listedPin.accepted" class="col-12 mt-4 text-center">
            <a href="/my/trades" class="btn btn-lg btn-trader text-light">View &amp; Manage Trades</a>
        </div>

    </div>

    <div v-if="isUser" class="modal fade" id="trade-confirm" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm {{ declineAll || declineTrader ? 'Decline' : 'Trade' }} Offer</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p v-if="declineAll" class="confirm-message confirm-decline-all">Are you sure you want to decline all the trade offers?</p>
                    <p v-else-if="declineTrader" class="confirm-message confirm-decline-all">Are you sure you want to decline only this trader's offers?</p>
                    <template v-else>
                    <p class="confirm-message confirm-accept">Are you sure you want to accept this pin trade?</p>
                    <div class="border border-secondary rounded p-2">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="autoVerify" id="autoVerify">
                            <label class="form-check-label" for="autoVerify"><strong>Auto Accept Verified</strong>
                                <div class="form-text">Auto accept trades that PIN & POP verifies as authentic and in good condition (photos will not be provided).</div>
                            </label>
                        </div>
                    </div>
                    </template>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">cancel</button>
                    <button v-if="declineAll" @click="declineOffers" type="button" class="btn btn-danger" data-bs-dismiss="modal">Yes, Decline All</button>
                    <button v-else-if="declineTrader" @click="declineOffers" type="button" class="btn btn-danger" data-bs-dismiss="modal">Yes, Decline Offers</button>
                    <button v-else @click="acceptOffer" type="button" class="btn btn-success" data-bs-dismiss="modal">Yes, Accept Trade</button>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Confetti from 'canvas-confetti';
export default {
    name: "TradeOffers",
    props: {
        listing: Object,
        offers: Array,
        traders: Array,
        user: {
            type: Object,
            default: () => ({id: null, username: null})
        },
        enhanced: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            listedPin: {...this.listing},
            tradeOffers: this.offers,
            accepted: { id: null },
            isPending: false,
            autoVerify: false,
            declineAll: false,
            declineTrader: null,
            tradeError: null,
            timerCount: this.listing.board.trading_at ? Date.parse(this.listing.board.trading_at) - Date.now() : 0
        }
    },
    mounted() {
        if (this.listing.accepted) {
            this.accepted = this.tradeOffers.find(o => o.accepted_at);
        }

        // const el = document.getElementById('listed-pin'),
        const el = document.getElementById('manage-trade-offers'),
            topX = el.offsetTop - document.getElementById('primary-navbar').offsetHeight;
        window.addEventListener('scroll', function() {
            if (window.scrollY > topX) {
                el.classList.add('snapped');
                if (el.dataset.offer) {
                    el.classList.add('with-offer');
                }
            } else {
                el.classList.remove('snapped', 'with-offer');
            }
        });

        document.getElementById('trade-confirm').addEventListener('hidden.bs.modal', () => {
            this.declineAll = false;
            this.declineTrader = null;
        });
    },
    computed: {
        isUser () {
            // return this.listing.pinventory.user.id === this.user.id;
            return this.listing.collection.user.id === this.user.id;
        },
        canTrade () {
            return this.timerCount < 1;
        },
        formattedTimerCount () {
            let minutes = Math.floor(this.timerCount / 60000);
            let seconds = ((this.timerCount % 60000) / 1000).toFixed(0);
            return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
        }
    },
    methods: {
        declineOffers () {
            let url = '/pin-trading/listings/' + this.listing.id + '/offers';
            if (this.declineTrader) {
                url += '/' + this.declineTrader;
            }
            axios.delete(url).then(response => {
                if (response.status === 200) {
                    const d = new Date();
                    this.accepted = { id: null };
                    this.tradeOffers.forEach(o => {
                        if (!this.declineTrader ||  o.collection.user_id === this.declineTrader) {
                            o.declined_at = d.getTime();
                            o.unavailable_at = d.getTime();
                        }
                    });
                }
            });
        },

        acceptOffer () {
            this.isPending = true;
            let end = Date.now() + (4 * 1000);

            // (function frame() {
            //     Confetti({
            //         particleCount: 4,
            //         angle: 60,
            //         spread: 55,
            //         origin: { x: 0 },
            //         zIndex: 10000
            //     });
            //     Confetti({
            //         particleCount: 4,
            //         angle: 120,
            //         spread: 55,
            //         origin: { x: 1 },
            //         zIndex: 10000
            //     });

            //     if (Date.now() < end) {
            //         requestAnimationFrame(frame);
            //     }
            // }());

            const d = new Date();
            axios.post('/pin-trading/trades', {
                listing: this.listing.id,
                offer: this.accepted.id,
                auto_verify: this.autoVerify
            }).then(response => {
                if (response.status === 200) {

                    (function frame() {
                        Confetti({
                            particleCount: 4,
                            angle: 60,
                            spread: 55,
                            origin: { x: 0 },
                            zIndex: 10000
                        });
                        Confetti({
                            particleCount: 4,
                            angle: 120,
                            spread: 55,
                            origin: { x: 1 },
                            zIndex: 10000
                        });

                        if (Date.now() < end) {
                            requestAnimationFrame(frame);
                        }
                    }());

                    this.listedPin.accepted = true;
                    this.tradeOffers.forEach(o => {
                        if (o.id === this.accepted.id) {
                            o.accepted_at = d.getTime();
                        } else {
                            o.declined_at = d.getTime();
                            o.unavailable_at = d.getTime();
                        }
                    });
                }
            }).catch(reason => {
                if (reason.response.status === 410) {
                    this.tradeError = reason.response.data.message;
                    this.accepted.unavailable_at = d.getTime();
                    this.accepted = { id: null };
                    this.isPending = false;
                }
            });
        }
    },

    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount -= 1000;
                    }, 1000);
                }
            },
            immediate: true
        }
    }
}
</script>
